import getField from '@form/formGenerator'

export const pageSaveUrl = `${import.meta.env.VITE_API_URL}/api/pages`

export const pageFormObject = {
  id: '',
  title: '',
  fullTitle: '',
  metaDescription: '',
  subTitle: '',
  description: '',
  isActive: false,
  missionId: '',
  pageType: ''
}

export const pageFormFields = (
  pageFormObject,
  updateFormObject,
  updateFormObjectProp,
  saveForm,
  errors,
  isLoading,
  t,
  pageTypes,
  languages
) => {
  const fields = [
    {
      type: 'select',
      name: 'language',
      label: t('labels.language'),
      value: pageFormObject.language,
      key: 'pageFormObject-language',
      cssClass: 'pageFormObject-type column is-12',
      options: languages,
      isRequired: true
    },
    {
      type: 'select',
      name: 'pageType',
      label: t('labels.page_type'),
      value: pageFormObject.pageType,
      key: 'pageFormObject-pageType',
      cssClass: 'page-type column is-12',
      withIcon: false,
      help: t('help.page_type_help'),
      options: pageTypes,
      disabled: false,
      isRequired: true
    },
    {
      type: 'text',
      name: 'title',
      label: t('labels.title'),
      value: pageFormObject.title,
      key: 'pageFormObject-title',
      cssClass: 'column is-12',
      isRequired: true
    },
    {
      type: 'text',
      name: 'fullTitle',
      label: t('labels.full_title'),
      value: pageFormObject.fullTitle,
      key: 'pageFormObject-fullTitle',
      cssClass: 'column is-12'
    },
    {
      type: 'text',
      name: 'subTitle',
      label: t('labels.sub_title'),
      value: pageFormObject.subTitle,
      key: 'pageFormObject-subTitle',
      cssClass: 'column is-12'
    },
    {
      type: 'text',
      name: 'metaDescription',
      label: t('labels.meta_description'),
      value: pageFormObject.metaDescription,
      key: 'pageFormObject-metaDescription',
      cssClass: 'column is-12'
    },
    {
      type: 'tinymce',
      config: 'full',
      name: "description",
      cssClass: 'column is-12 mission-description',
      disabled: false,
      label: t('labels.content'),
      initialValue: pageFormObject.description,
      isRequired: true
    },
    {
      type: 'switcher',
      name: 'isActive',
      label: t('labels.is_active'),
      value: pageFormObject.isActive,
      cssClass: 'column is-6',
      key: 'pageFormObject-isActive',
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'pageFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(pageFormObject.id),
      key: 'pageFormObject-id'
    },
    {
      type: 'hidden',
      name: 'missionId',
      value: parseInt(pageFormObject.missionId),
      key: 'sterilizationCitizenCallFormObject-missionid'
    },
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject, updateFormObjectProp)
  })
}